import {
    Gutters,
    MainButton,
    MobileConfirmDialog,
    TDialogStore,
    Typography,
    useDialogStore,
} from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useShallow } from 'zustand/react/shallow'
import i18n from '../../../i18n/i18next'
import { bs } from '../../../state/bound.store'
import { loadingSignal } from '../../../state/overlayState/overlaySignals'
import { NavigationView } from '../../layout/NavigationView'

const DELETION_POINTS = [
    'Email address',
    'Phone number',
    'Password (encrypted)',
    'First and last name',
    'Profile picture',
    'Team data',
]
export const DeleteAccountPage = () => {
    const { replaceDialog, clearDialog }: TDialogStore = useDialogStore(
        useShallow((s: TDialogStore) => ({
            clearDialog: s.clearDialog,
            replaceDialog: s.replaceDialog,
        }))
    )

    const footer = () => {
        return (
            <Stack
                spacing={'16px'}
                justifyContent="center"
                alignItems="center"
                marginBottom={'24px'}
                paddingBottom="16px"
            >
                <MainButton
                    onClick={() => {
                        replaceDialog({
                            node: (
                                <MobileConfirmDialog
                                    text={i18n.t('delete-account.delete-text')}
                                    header={i18n.t('delete-account.delete')}
                                    cancelText={i18n.t('general.cancel')}
                                    confirmText={i18n.t('general.delete')}
                                    confirmBtnStyle="destructiveBorderless"
                                    onConfirm={async () => {
                                        loadingSignal.value = true
                                        await bs().deleteRequest()
                                        clearDialog()
                                        loadingSignal.value = false
                                    }}
                                    onCancel={() => {
                                        clearDialog()
                                    }}
                                />
                            ),
                            backdropClosable: false,
                        })
                    }}
                    variant="destructiveBorderless"
                >
                    {i18n.t('account.acount-delete-request')}
                </MainButton>
            </Stack>
        )
    }
    return (
        <NavigationView
            navigationBarTitle={i18n.t('delete-account.delete')}
            backButtonAction={() => {
                window.goBack()
            }}
            footer={footer()}
            usePageTransition
        >
            <Gutters style={{ height: '100%' }} topPadding="0px">
                <Stack spacing={'16px'} paddingTop={'24px'}>
                    <Typography variant="bodyBold">
                        {i18n.t('delete-account.header')}
                    </Typography>
                    <Typography variant="bodyRegular">
                        {i18n.t('delete-account.sub-header')}
                    </Typography>
                    <Stack paddingLeft={'16px'} spacing={'8px'}>
                        {DELETION_POINTS.map((point, index) => {
                            return (
                                <Typography variant="bodyRegular" key={point}>
                                    •{' '}
                                    {i18n.t(
                                        `delete-account.deletion-points.${index}`
                                    )}
                                </Typography>
                            )
                        })}
                    </Stack>
                </Stack>
            </Gutters>
        </NavigationView>
    )
}
